export default "__VITE_ASSET__JrRC8uuf__"